import styled from 'styled-components';

export const Container = styled.div`
  padding: 12px;
  margin: 0 auto;
  max-width: 1280px;
`;

export const HeaderContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  flex-wrap: wrap;
`;

export const Title = styled.h1`
  color: #1f1f1f;
  margin-bottom: 0;
  font-size: 26px;
  line-height: 1.2;
`;

export const Card = styled.div`
  background: #fff;
  padding: 18px;
  border-radius: 10px;
  border: 1px solid #f0f0f0;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.06);
  margin-bottom: 20px;
`;

export const AccessDeniedCard = styled(Card)`
  border: 1px solid #f5c6cb;
  background-color: #f8d7da;
  color: #721c24;
  text-align: center;
`;

export const FormGroup = styled.div`
  margin-bottom: 15px;
`;

export const Label = styled.label`
  display: block;
  margin-bottom: 5px;
  font-weight: bold;
  color: #555;
`;

export const Input = styled.input`
  width: 100%;
  padding: 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 16px;
  box-sizing: border-box;
`;

export const Hint = styled.small`
  color: #777;
  font-size: 12px;
  margin-top: 5px;
  display: block;
`;

export const SubmitButton = styled.button`
  padding: 10px 20px;
  background-color: #28a745;
  color: white;
  border: none;
  border-radius: 4px;
  cursor: pointer;
  font-size: 16px;

  &:disabled {
    opacity: 0.7;
  }
`;

export const ErrorMessage = styled.div`
  background-color: #f8d7da;
  color: #721c24;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
`;

export const SuccessMessage = styled.div`
  background-color: #d4edda;
  color: #155724;
  padding: 10px;
  border-radius: 4px;
  margin-bottom: 10px;
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  margin-top: 10px;
`;

export const Th = styled.th`
  text-align: left;
  padding: 12px;
  border-bottom: 2px solid #ddd;
  background-color: #f8f9fa;
  color: #333;
`;

export const Td = styled.td`
  padding: 12px;
  border-bottom: 1px solid #ddd;
  color: #555;
`;
